import { render, staticRenderFns } from "./WebsiteLink.vue?vue&type=template&id=20f991ba&"
import script from "./WebsiteLink.vue?vue&type=script&lang=js&"
export * from "./WebsiteLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports